<section>
  <header class="wizard-nav">
    <ol>
      @for (step of steps; track step; let i = $index) {
        <li>
          <a
            (click)="selectStepByIndex(i)"
            [ngClass]="{
              active: selectedIndex === i,
              completed: step.completed,
              visited: i > selectedIndex,
              readonly: readonly
            }">
            @if (step.stepLabel) {
              <ng-container [ngTemplateOutlet]="step.stepLabel.template">
                <span class="circle-icon">{{ i + 1 }}</span>
                <br />
              </ng-container>
            } @else {
              {{ step.label }}
            }
          </a>
        </li>
      }
    </ol>
  </header>

  <div class="wizard-body">
    <ng-container [ngTemplateOutlet]="selected.content"></ng-container>
  </div>
</section>
